.root {
  & {
    padding: calc(var(--theme--tokens--card--padding) / 2) var(--theme--tokens--card--padding);
    flex: 1;
  }
}